// extracted by mini-css-extract-plugin
export var logo = "_l4-2";
export var logoWrapper = "_l4-1";
export var strip = "_l4-0";